import React from 'react'
import { Link } from 'react-router-dom'

import { AddCircleOutline, AssignmentTurnedInOutlined, BarChart, CancelOutlined, CheckCircleOutline, CloudDoneOutlined, DataUsage, ErrorOutline, HourglassEmpty, NoteAddOutlined, PanToolOutlined, ReceiptOutlined, ThumbDownOutlined, ThumbUpOutlined, TrendingUp, WorkOutlineOutlined } from '@material-ui/icons'

import './Sidebar.css'

const Sidebar = ({ section, admin, translator, setShowSidebar, client }) => {
    const activeStyle = {
        backgroundColor: '#ff7f45'
    }

    return (
        <div className="sidebar py-20 overflow-y-auto">
            <h3 className="my-20 px-20">Menu</h3>
            {admin &&
              <nav className="d-flex flex-column">
                <Link to="/admin/index" style={section === "index" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <BarChart fontSize="small" />
                    <span className="pl-10">Overview</span>
                </Link>
                <Link to="/admin/urgent" style={section === "urgent" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <HourglassEmpty fontSize="small" />
                    <span className="pl-10">Urgent projects</span>
                </Link>
                <Link to="/admin/pending" style={section === "pending" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <ErrorOutline fontSize="small" />
                    <span className="pl-10">Pending projects</span>
                </Link>
                <Link to="/admin/unassigned" style={section === "unassigned" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <NoteAddOutlined fontSize="small" />
                    <span className="pl-10">Unassigned projects</span>
                </Link>
                <Link to="/admin/ongoing" style={section === "ongoing" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <TrendingUp fontSize="small" />
                    <span className="pl-10">Ongoing projects</span>
                </Link>
                <Link to="/admin/allocations" style={section === "allocations" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <DataUsage fontSize="small" />
                    <span className="pl-10">Incomplete allocations</span>
                </Link>
                <Link to="/admin/declined" style={section === "declined" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <CancelOutlined fontSize="small" />
                    <span className="pl-10">Declined allocations</span>
                </Link>
                <Link to="/admin/completed" style={section === "completed" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <CheckCircleOutline fontSize="small" />
                    <span className="pl-10">Completed translations</span>
                </Link>
                <Link to="/admin/verified" style={section === "verified" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <ThumbUpOutlined fontSize="small" />
                    <span className="pl-10">Verified projects</span>
                </Link>
                <Link to="/admin/concluded" style={section === "concluded" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <CloudDoneOutlined fontSize="small" />
                    <span className="pl-10">Concluded projects</span>
                </Link>
                <Link to="/admin/unapproved" style={section === "unapproved" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <PanToolOutlined fontSize="small" />
                    <span className="pl-10">Unapproved translators</span>
                </Link>
                <Link to="/admin/new-requests" style={section === "new-requests" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <ReceiptOutlined fontSize="small" />
                    <span className="pl-10">New Requests</span>
                </Link>
                <Link to="/admin/ongoing-requests" style={section === "ongoing-requests" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <WorkOutlineOutlined fontSize="small" />
                    <span className="pl-10">Ongoing Requests</span>
                </Link>
                <Link to="/admin/concluded-requests" style={section === "concluded-requests" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <AssignmentTurnedInOutlined fontSize="small" />
                    <span className="pl-10">Concluded Requests</span>
                </Link>
              </nav>
            }
            {translator &&
              <nav className="d-flex flex-column">
                <Link to="/translator/index" style={section === "index" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <BarChart fontSize="small" />
                    <span className="pl-10">Overview</span>
                </Link>
                <Link to="/translator/new" style={section === "new" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <AddCircleOutline fontSize="small" />
                    <span className="pl-10">New projects</span>
                </Link>
                <Link to="/translator/ongoing" style={section === "ongoing" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <TrendingUp fontSize="small" />
                    <span className="pl-10">Ongoing projects</span>
                </Link>
                <Link to="/translator/declined" style={section === "declined" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <ThumbDownOutlined fontSize="small" />
                    <span className="pl-10">Declined projects</span>
                </Link>
              </nav>
            }
            {client &&
              <nav className="d-flex flex-column">
                <Link to="/projects/index" style={section === "index" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <BarChart fontSize="small" />
                    <span className="pl-10">Overview</span>
                </Link>
                <Link to="/projects/inactive" style={section === "inactive" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <ErrorOutline fontSize="small" />
                    <span className="pl-10">Inactive projects</span>
                </Link>
                <Link to="/projects/ongoing" style={section === "ongoing" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <TrendingUp fontSize="small" />
                    <span className="pl-10">Ongoing projects</span>
                </Link>
                <Link to="/projects/completed" style={section === "completed" ? activeStyle : {}} className="d-flex align-center p-20" onClick={() => setShowSidebar(false)}>
                    <CheckCircleOutline fontSize="small" />
                    <span className="pl-10">Completed projects</span>
                </Link>
              </nav>
            }
        </div>
    )
}

export default Sidebar
